/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/Action/Share
 * @desc Share EntityStateWorkflow
 */

import { EntityActionShare } from 'labstep-web/components/Entity/Action/Share';
import type React from 'react';
import type { EntityStateWorkflowActionShareProps } from './types';

export const EntityStateWorkflowActionShare: React.FC<
  EntityStateWorkflowActionShareProps
> = ({ entityStateWorkflow }) => (
  <EntityActionShare entity={entityStateWorkflow} />
);
